'use client';

import { useEffect, useState } from 'react';
import { Button } from '@/shared/ui/shadcn/button';
import { Sun, Moon, Laptop } from 'lucide-react';
import { useThemeMode, useThemeActions } from '@/shared/ui/model';
import type { ThemeMode } from '@/shared/ui/model';

export function ThemeSwitcher() {
  const [mounted, setMounted] = useState(false);
  const themeMode = useThemeMode();
  const { setThemeMode } = useThemeActions();

  useEffect(() => {
    setMounted(true);
  }, []);

  const cycleTheme = () => {
    const themes: ThemeMode[] = ['light', 'dark', 'system'];
    const currentIndex = themes.indexOf(themeMode);
    const nextIndex = (currentIndex + 1) % themes.length;
    const nextTheme = themes[nextIndex];
    if (nextTheme) {
      setThemeMode(nextTheme);
    }
  };

  const getIcon = () => {
    switch (themeMode) {
      case 'dark':
        return <Moon className="h-4 w-4" />;
      case 'light':
        return <Sun className="h-4 w-4" />;
      default:
        return <Laptop className="h-4 w-4" />;
    }
  };

  if (!mounted) {
    return (
      <Button variant="ghost" size="icon" className="h-9 w-9">
        <Sun className="h-4 w-4" />
        <span className="sr-only">Toggle theme</span>
      </Button>
    );
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      className="h-9 w-9"
      onClick={cycleTheme}
    >
      {getIcon()}
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
